import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Image from "@app/analytics/assets/business_entrepreneurship_growth.png";

import Stack from "@rui/Stack";

import { Card } from "../styles";

const DetailsEducationCard = () => {
  return (
    <Card sx={{ width: "300px", padding: 2 }} spacing={2}>
      <Stack
        sx={{ bgcolor: "shades.ghost.500", borderRadius: "4px", padding: 1 }}
        variant="center"
      >
        <Box component="img" src={Image} width="120px" />
      </Stack>
      <Stack spacing={0.5} sx={{ color: "shades.neutral.800" }}>
        <Typography variant="bodySecondaryMed">Get the details</Typography>
        <Typography variant="bodySecondaryReg">
          Click on any update in your Newsfeed to see more details and context.
        </Typography>
      </Stack>
    </Card>
  );
};

export default DetailsEducationCard;
